export default {
  title: 'Document Control',
  search: {
    placeholder: 'Search title / model / cert body'
  },
  columns: {
    countryRegion: 'Country/Region',
    title: 'Title',
    productCategory: 'Product Category',
    certType: 'Certificate Type',
    certProject: 'Certification Project',
    productModel: 'Product Model',
    certOrg: 'Cert Body',
    effectiveDate: 'Effective Date',
    expiryDate: 'Expiry Date',
    remark: 'Remark',
    actions: 'Actions'
  },
  actions: {
    batchDownload: 'Download',
    search: 'Search',
    reset: 'Reset',
    preview: 'Preview'
  },
  preview: {
    title: 'Preview'
  },
  messages: {
    noSelection: 'Select documents first',
    loadFailed: 'Failed to load documents',
    downloadFailed: 'Download failed',
    downloadSuccess: 'Download completed',
    noFile: 'No file available for selected documents',
    tenantOnly: 'Document control is available for Shokz tenant only',
    previewFailed: 'Unable to preview',
    previewUnavailable: 'Unable to preview'
  },
  summary: {
    total: '{count} records'
  }
}
